<template>
  <div class="import">
    <div class="content">
      <div class="section" :class="'marketing'">
        <div class="title">{{ $t('admin.views.import.title') }}</div>
        <!-- <a target="_blank" :href="imageURL(section_index)">Ver ejemplo</a> -->
        <!-- <img class="icon" :src='"/img/import/"+ section_index +".png"'> -->

        <div class="input">
          <input
            type="file"
            :name="'marketing'"
            accept="image/jpeg"
            :id="'marketing'"
            :ref="'marketing'"
            class="inputfile"
            @change="uploadMarketingPhoto()"
          />
          <label for="marketing">
            <v-icon class="icon">upload</v-icon>
            {{ $t('admin.views.import.photo') }}
          </label>
        </div>

        <template v-for="(section, section_index) in sections">
          <div
            class="section"
            :class="section_index"
            :style="section.parentLabel ? 'margin-bottom: 40px;' : true"
          >
            <div class="title" v-if="!section.son">{{ section.label }}</div>
            <div class="subtitle" v-if="section.parentLabel">
              {{ section.parentLabel }}
            </div>
            <div class="subtitle" v-else-if="section.son">
              {{ section.label }}
            </div>

            <a target="_blank" :href="imageURL(section_index)">{{ $t('admin.views.import.example') }}</a>
            <!-- <img class="icon" :src='"/img/import/"+ section_index +".png"'> -->

            <div class="input">
              <input
                type="file"
                :name="section_index"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                :id="section_index"
                :ref="section_index"
                class="inputfile"
                @change="uploadFile(section_index)"
              />
              <label v-if="section.filename" :for="section_index">
                <img class="icon" src="/img/excel.jpg" />
                {{ section.filename }}
              </label>
              <label v-else :for="section_index">
                <v-icon class="icon">upload</v-icon>
                {{ $t('admin.views.import.excel') }}
              </label>
              <v-icon
                v-if="section.filename"
                class="icon delete"
                color="#ba2b21"
                @click="deleteFile(section_index)"
                >delete</v-icon
              >
            </div>

            <div class="description" v-if="!section.parentLabel">
              <v-layout row>
                <v-flex xs3> </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('admin.views.import.description')"
                    v-model="section.description"
                    @input="descriptionChanges.push(section_index)"
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs3> </v-flex>
              </v-layout>
            </div>

            <div
              :class="{
                visible:
                  section.filename || descriptionChanges.includes(section_index)
              }"
              @click="save(section_index)"
              class="bttn"
            >
              <span v-if="section.filename">{{ $t('admin.views.import.import_excel') }}</span>
              <span
                v-if="
                  section.filename && descriptionChanges.includes(section_index)
                "
              >
                y
              </span>
              <span v-if="descriptionChanges.includes(section_index)"
                >{{ $t('admin.views.import.update') }}</span
              >
            </div>
          </div>
        </template>

        <div class="clients part"></div>

        <div class="poblation part"></div>

        <div class="title">{{ $t('admin.views.import.rrss') }}</div>
        <div class="input">
          <input 
            type="file" 
            :name="'RRSS'" 
            accept="pdf" 
            :id="'RRSS'" 
            :ref="'RRSS'" 
            class="inputfile" 
            @change="uploadRRSS()" 
          />
          <label for="RRSS">
            <v-icon class="icon">upload</v-icon>
            {{ $t('admin.views.import.rrss_description') }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Slider from "@/components/domain/admin/Slider";

export default {
  name: "Import",
  props: { page: String },
  components: { Slider },
  data() {
    return {
      sections: {
        competence: { label: i18n.t('general.competence') },
        sales_week: {
          label: i18n.t('general.sales'),
          parentLabel: i18n.t('admin.views.import.sales_week')
        },
        sales: { label: i18n.t('admin.views.import.sales_weekend'), son: true },
        pmix: { label: i18n.t('admin.views.import.pmix') },
        consume: { label: i18n.t('admin.views.import.consume') }
      },

      marketingPhoto: null,

      descriptionChanges: []
    };
  },
  computed: {
    diagnosticDescriptions() {
      var descriptions = this.$store.getters[
        "locations/getDiagnosticDescriptions"
      ];
    }
  },
  methods: {
    imageURL(section_index) {
      return window.location.origin + "/img/import/" + section_index + ".png";
      // return "https://lsm.mcdonalds.es/img/import/"+ section_index +".png";
    },

    uploadMarketingPhoto() {
      var self = this;
      var file = this.$refs["marketing"].files[0];

      if (file.name.includes(".jpg") || file.name.includes(".jpeg")) {
        this.marketingPhoto = file.name;
        this.$overlay.loading();
        var aData = {};
        aData.file = this.marketingPhoto
          ? this.$refs["marketing"].files[0]
          : false;
        this.$store
          .dispatch("locations/updateMarketingPhoto", aData)
          .then(function(response) {
            self.$overlay.hide();
            if (response.status) {
              self.$popup.alert(i18n.t('admin.views.import.info_updated'));
              self.deleteFile("marketing");
            } else {
              self.$popup.alert(response.error.message);
            }
          });
      } else {
        this.$popup.alert(i18n.t('admin.views.import.invalid_file'));
      }
    },

    uploadFile(section_index) {
      var file = this.$refs[section_index][0].files[0];

      if (file.name.includes(".xls") || file.name.includes(".xlsx")) {
        var sections = { ...this.sections };
        sections[section_index].filename = file.name;
        this.sections = sections;
      } else {
        this.$popup.alert(i18n.t('admin.views.import.popup.invalid_file'));
      }
    },

    deleteFile(section_index) {
      var sections = { ...this.sections };
      if (section_index) sections[section_index].filename = false;
      this.sections = sections;
    },

    save(section_index) {
      var self = this;

      var aData = {};
      aData.file = this.sections[section_index].filename
        ? this.$refs[section_index][0].files[0]
        : false;
      aData.section = JSON.stringify({
        section: section_index,
        description: this.sections[section_index].description
      });

      // aData.file = this.$refs[section_index][0].files[0];
      // aData.section = JSON.stringify({'section': section_index ,'description': this.sections[section_index].description});

      this.$overlay.loading();
      this.$store
        .dispatch("locations/updateDiagnosticSection", aData)
        .then(function(response) {
          self.$overlay.hide();
          if (response.status) {
            self.$popup.alert(i18n.t('admin.views.import.info_updated'));
            var descriptionChanges = self.descriptionChanges;
            descriptionChanges.splice(
              descriptionChanges.indexOf(aData.section),
              1
            );
            self.descriptionChanges = descriptionChanges;
            self.deleteFile(section_index);
          } else {
            self.$popup.alert(response.error.message);
          }
        });
    },

    uploadRRSS() {
      const self = this;
      const file = this.$refs["RRSS"].files[0];

      // Validate that it's a PDF
      if (file && file.name.toLowerCase().endsWith(".pdf")) {
        this.pdfFileName = file.name;
        this.$overlay.loading();

        const aData = {
          file: this.$refs["RRSS"].files[0] || false,
        };

        this.$store
          .dispatch("locations/uploadRRSS", aData)
          .then(function (response) {
            self.$overlay.hide();
            if (response.status) {
              self.$popup.alert(i18n.t("admin.views.import.info_updated"));
              self.$refs["RRSS"].value = '';
            } else {
              self.$popup.alert(response.error.message);
            }
          });
      } else {
        this.$popup.alert(i18n.t("admin.views.import.popup.invalid_file_rrss"));
      }
    }
  },
  watch: {
    // call again the method if the route changes
    // '$route': 'loadDataPage'
  },
  created() {
    var self = this;
    this.$store.commit("setTitle", "Importar excels");
    this.$store.commit("setMenuVisible", false);

    this.$store
      .dispatch("locations/loadDiagnosticDescriptions", {})
      .then(function(response) {
        var sections = { ...self.sections };
        for (var section_index in response) {
          var section = response[section_index];
          if (sections[section_index]) {
            sections[section_index].description = section.description;
          }
        }
        self.sections = sections;
      });
  },
  beforeRouteLeave(to, from, next) {
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.section {
  margin: 0px auto 90px;

  .title {
    width: fit-content;
    padding: 30px 0px;
    width: auto;
    font-size: 20px !important;
    background-color: black;
    color: white;
    margin: 35px 0;
    background-color: #eee;
    -webkit-print-color-adjust: exact;
    color: #999;
    margin-bottom: 20px;
    text-transform: uppercase;
  }

  .subtitle {
    background-color: #000;
    color: white;
    font-size: 18px;
    width: fit-content;
    margin: 5px auto;
    padding: 3px 10px;
  }

  .input {
    width: fit-content;
    margin: 0 auto;

    .inputfile {
      width: 0.1px;
      height: 0.1px;
      opacity: 0;
      overflow: hidden;
      position: absolute;
      z-index: -1;
    }

    .inputfile + label {
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      padding: 5px 15px;
      background-color: rgba(0, 0, 0, 0.15);
      border-radius: 3px;

      &:hover {
        background-color: rgba(0, 0, 0, 0.2);
      }
    }

    .inputfile:focus + label,
    .inputfile + label:hover {
    }

    .icon {
      display: flex;
      align-items: center;
      width: 25px;
      height: 25px;
      margin: 0;
      margin-right: 10px;
    }
    .delete {
      display: inline-block;
      width: fit-content;
      margin: 0;
      margin-bottom: 3px;
    }
  }

  .bttn {
    background-color: #8bc34a;
    width: fit-content;
    margin: 0 auto;
    margin-top: 30px;
    color: white;
    border-radius: 3px;
    font-size: 16px;
    cursor: pointer;
    opacity: 1;
    transition: 0.5s;
    text-transform: uppercase;
    height: 0px;
    padding: 0;
    min-height: 5px;

    &::first-letter {
      text-transform: uppercase;
    }

    &.visible {
      height: 40px;
      padding: 8px 25px;
    }
  }
}
</style>
